<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.563 13.563">
        <path id="Caminho_39" data-name="Caminho 39"
            d="M6.782,0A6.865,6.865,0,0,0,0,6.782a6.865,6.865,0,0,0,6.782,6.782,6.865,6.865,0,0,0,6.782-6.782A6.865,6.865,0,0,0,6.782,0Zm3.875,7.266H7.266v3.391H6.3V7.266H2.906V6.3H6.3V2.906h.969V6.3h3.391Z" />
    </svg>
</template>
